import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Card from '../common/Card';
import Button from '../common/Button';
import Input from '../common/Input';
import api from '../../services/api';
import { formatCurrency } from '../../utils/formatters';
import '../../styles/subscription.css';

const SubscriptionRenew = () => {
  const navigate = useNavigate();
  const [paymentMethod, setPaymentMethod] = useState('mpesa');
  const [processing, setProcessing] = useState(false);

  const handleRenew = async () => {
    setProcessing(true);
    try {
      await api.post('/subscription.php/renew', {
        payment_method: paymentMethod
      });
      navigate('/settings/subscription');
    } catch (error) {
      console.error('Renewal failed:', error);
    } finally {
      setProcessing(false);
    }
  };

  return (
    <div className="subscription-renew">
      <div className="renew-header">
        <h1>Renew Subscription</h1>
        <Button variant="secondary" onClick={() => navigate('/settings/subscription')}>
          Back
        </Button>
      </div>

      <Card>
        <div className="renew-info">
          <h3>Your subscription has expired</h3>
          <p>To continue using Harvyq ERP, please renew your subscription.</p>
          
          <div className="renew-amount">
            <span>Amount Due:</span>
            <strong>{formatCurrency(1999)}</strong>
          </div>
        </div>

        <div className="payment-methods">
          <h4>Select Payment Method</h4>
          <div className="method-options">
            <label className="method-option">
              <input
                type="radio"
                name="payment"
                value="mpesa"
                checked={paymentMethod === 'mpesa'}
                onChange={(e) => setPaymentMethod(e.target.value)}
              />
              <span>M-Pesa</span>
            </label>
            <label className="method-option">
              <input
                type="radio"
                name="payment"
                value="card"
                checked={paymentMethod === 'card'}
                onChange={(e) => setPaymentMethod(e.target.value)}
              />
              <span>Card Payment</span>
            </label>
            <label className="method-option">
              <input
                type="radio"
                name="payment"
                value="bank"
                checked={paymentMethod === 'bank'}
                onChange={(e) => setPaymentMethod(e.target.value)}
              />
              <span>Bank Transfer</span>
            </label>
          </div>
        </div>

        {paymentMethod === 'mpesa' && (
          <div className="mpesa-instructions">
            <p>You will receive an M-Pesa prompt on your phone</p>
            <p className="small">Please ensure your phone is nearby</p>
          </div>
        )}

        <div className="renew-actions">
          <Button 
            variant="primary" 
            onClick={handleRenew}
            loading={processing}
            fullWidth
          >
            {processing ? 'Processing...' : 'Pay & Renew Subscription'}
          </Button>
        </div>
      </Card>
    </div>
  );
};

export default SubscriptionRenew;